import { render, staticRenderFns } from "./ShippingSettings.vue?vue&type=template&id=916d94c8"
import script from "./ShippingSettings.vue?vue&type=script&lang=js"
export * from "./ShippingSettings.vue?vue&type=script&lang=js"
import style0 from "./ShippingSettings.vue?vue&type=style&index=0&id=916d94c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports